import { Component } from '@angular/core';
import { SOLUTION_PAGE_CONFIGS } from 'src/app/shared/components/solution-page/solution-page.config';

@Component({
  selector: 'app-solution5',
  templateUrl: './solution5.component.html',
  styleUrls: ['./solution5.component.scss'],
})
export class Solution5Component {
  readonly pageConfig = SOLUTION_PAGE_CONFIGS[5];
}
